enum Make {
    Chevy,
    Dodge,
    Ford,
    GMC,
    Hino,
    Mitsubishi,
    Ram
}

const Makes = {
    Ford: {
        E450: {
            size17: {
                capacity: {
                    emptyWeight: 8120,
                    grossVehicleWeight: 14050,
                    hitchRating: 10000,
                    cubicCapacity: 849,
                    payload: 5930
                },
                fuel: {
                    mileageRate: 11,
                    tankCapacity: 37
                },
                year: [1998, 2000, 2006, 2007]
            }
        }
    }
}

export default Make